import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Subscription } from 'rxjs';
import { SessionTimeoutButtons } from '../models/modal-timeout.config';
import { SessionTimeoutService } from '../services/session-timeout.service';
import { take } from 'rxjs/operators';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { environment } from 'src/environments/environment';
import { MetadataService } from '@carm/_core/metadata/services';
import { EnvironmentName } from 'src/environments/baseEnvironmentConfigs';
import { AuthService, UserToken } from '@carm/_auth/spartacus/core/auth';


@Component({
    template: '',
    selector: 'carm-session-timeout',
})

export class SessionTimeoutComponent implements OnInit, OnDestroy {

  subscriptionsArray: Subscription[] = [];
  userToken: UserToken;
  allowMultipleLogin: boolean = false;

  constructor(
      private sessionTimeoutService: SessionTimeoutService,
      private idle: Idle,
      private authService: AuthService,
      private userService: UserService,
      private metadataService: MetadataService,
      private router: CarmRouter,
      private keepalive: Keepalive,
      ) {
  }

  ngOnInit() {
      this.allowMultipleLogin = environment.name === EnvironmentName.Local;
        this.keepalive.interval(10);
      this.setupIdle();
      this.setupSubscriptions();
      
  }

  setupIdle() {
      // if the expiry date in the localstorage is not valid, clears signout the user
      if (this.sessionTimeoutService.isSessionIdleExpired()) {
          this.timeOut();
      }
      this.sessionTimeoutService.configIdle();
  }

  setupSubscriptions() {
      // time out event
      this.subscriptionsArray.push(
          this.idle.onTimeout.subscribe(() => { this.timeOut(); }),
      );

      this.subscriptionsArray.push(
          this.idle.onTimeoutWarning.subscribe((countdown: number) => {
              this.sessionTimeoutService.checkTimeoutWarning(countdown);
          }),
      );

      this.subscriptionsArray.push(
          this.authService.isUserLoggedIn().subscribe( (isUserLoggedIn: boolean) => { // takeUntil needed?
              if ( isUserLoggedIn ) {
                  this.sessionTimeoutService.startWatch();
              } else {
                  this.sessionTimeoutService.stopWatch();
              }
          }),
      );
    
      if (!this.allowMultipleLogin){
        this.subscriptionsArray.push(
            this.keepalive.onPing.subscribe(() => this.tokenRefresh()),
        );
      }

      this.subscribeToButtons();
  }

  subscribeToButtons() {
      this.subscriptionsArray.push(
          this.sessionTimeoutService.lastButtonClickedObs.subscribe((sessionBtn: SessionTimeoutButtons ) => {
              switch (sessionBtn) {
                  case SessionTimeoutButtons.pastTimeout:
                  case SessionTimeoutButtons.exitSession:
                      this.exitSession();
                      break;
                  case SessionTimeoutButtons.extendSession:
                      // reset timer
                      this.extendSession();
                      break;
              }
          }),
      );
  }

  timeOut() {
      this.authService.logout();
      this.userService.logOut();
      this.metadataService.resetMetadata();
      this.sessionTimeoutService.userTimeout();
  }

  exitSession() {
      this.timeOut();
      this.sessionTimeoutService.closeDialog();
      this.router.carmNavigate([RoutesConst.Login]);
  }

  extendSession() {
      this.sessionTimeoutService.closeDialog();
      this.sessionTimeoutService.startWatch();
  }

  tokenRefresh() {
    this.authService.getUserToken().pipe(take(1)).subscribe((token) => {
            if (token) {
              this.userToken = token;
              this.authService.refreshUserToken(this.userToken);
            }
          });

  }

  ngOnDestroy() {
    this.subscriptionsArray.forEach((subscription: Subscription) => subscription.unsubscribe());
}

}
